import script from "./CaskWebChatFab.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskWebChatFab.vue?vue&type=script&setup=true&lang=js"

import "./CaskWebChatFab.vue?vue&type=style&index=0&id=662fb573&lang=scss&scoped=true"
import "./CaskWebChatFab.vue?vue&type=style&index=1&id=662fb573&lang=scss&scoped=true"
import "./CaskWebChatFab.vue?vue&type=style&index=2&id=662fb573&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-662fb573"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QInput from 'quasar/src/components/input/QInput.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QScrollArea,QList,QItem,QBtn,QAvatar,QImg,QBadge,QSeparator,QToggle,QIcon,QInfiniteScroll,QSpinnerDots,QChatMessage,QInput});qInstall(script, 'directives', {Ripple});
